import { gql } from "@apollo/client";

export const STOP_RUN = gql`
  mutation StopRunNext($stackId: ID!, $runId: ID!) {
    runStop(stack: $stackId, run: $runId) {
      id
    }
  }
`;
